import { EquationNode } from "../nodes/EquationNode";
import { useEffect, useState, memo, useRef } from "react";
import loader from "../loader.gif";
import interact, { makeNewRestrictedPosition } from "../../src/interact";

function loadJS(url: string, id: string, resolve: () => void, reject: () => void) {
    var headElem = document.getElementsByTagName("head")[0];
    var existingElement = document.getElementById(id);
    if (existingElement && existingElement.dataset.loaded == "true") {
        resolve();
        return;
    }
    var script = document.createElement("script");
    script.id = id;
    script.type = "text/javascript";
    resolveLoad(script, resolve, reject);
    script.src = url;
    headElem.appendChild(script);
}

function loadCSS(url: string, id: string, resolve: () => void, reject: () => void) {
    var headElem = document.getElementsByTagName("head")[0];
    var existingElement = document.getElementById(id);
    if (existingElement && existingElement.dataset.loaded == "true") {
        resolve();
        return;
    }
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.id = id;
    resolveLoad(link, resolve, reject);
    link.href = url;
    headElem.appendChild(link);
}

function resolveLoad(elem: HTMLElement, resolve: () => void, reject: () => void) {
    elem.onload = function () {
        elem.dataset.loaded = "true";
        resolve();
    };
    elem.onerror = reject;
}

function loadEditorLib(resolve: () => void, reject: () => void) {
    loadJS(
        "https://cdn.masterymanager.com/equation-editor/editor-1.12.0.min.js",
        "equation-editor-js",
        function () {
            loadCSS(
                "https://cdn.masterymanager.com/equation-editor/editor-1.12.0-student.css",
                "equation-editor-css",
                resolve,
                reject
            );
        },
        reject
    );
}
interface EquationEditorIFace {
    getSvg(resolve: (svg: string) => void, reject: () => void): void;
    setLatex(latex: string): void;
    getLatex(): string;
}
const EditorContainer = memo(function ContainerElement(props: { uuid: string }) {
    return <div className="equation-editor-container" id={props.uuid}></div>
});

export default function (props: { close: () => void, writeEquation: (svg: string, latex: string, editNode: EquationNode | null) => void, editNode: EquationNode | null }) {
    let [loading, setLoading] = useState(true);
    let [error, setError] = useState(false);
    let [editor, setEditor] = useState<EquationEditorIFace | null>(null)
    let [uuid, setuuid] = useState(crypto.randomUUID() as string);
    let draggableAreaRef = useRef(null as HTMLDivElement | null);
    useEffect(() => {
        loadEditorLib(() => {
            setLoading(false);
        }, () => {
            setLoading(false);
            setError(true);
        })
    }, [])
    useEffect(() => {
        if (!loading && !error) {
            let selector = `#${uuid}`;
            var url =
                "https://5zp7ryegak.execute-api.us-east-1.amazonaws.com/test/converters";
            let editor: EquationEditorIFace | undefined = undefined
            //@ts-ignore
            editor = new EquationEditor(selector, { converterURL: url })
            if (editor == undefined) { throw "Unexpected undefined EquationEditor" }
            if (props.editNode) {
                editor.setLatex(props.editNode.getLatex());
            }
            setEditor(editor)
        }
    }, [loading, error, props.editNode]);

    useEffect(() => {
        let position = { x: 0, y: 0 };
        if (!draggableAreaRef.current) return;
        let draggableArea = draggableAreaRef.current;
        let header = draggableArea.querySelector(".equation-editor-popup-header")
        if (!header || !(header instanceof HTMLElement)) return;

        interact(header).draggable({
            max: 1,
            autoScroll: {
                enabled: true
            },
            listeners: {
                /**
                 * 
                 * @param {import("@interactjs/types").InteractEvent} evt 
                 */
                move: (evt) => {
                    position = makeNewRestrictedPosition(evt, position);
                    draggableArea.style.transform = `translate(${position.x}px, ${position.y}px)`
                },
            }
        })

        interact(draggableArea).resizable({
            edges: { left: true, right: true, bottom: true, top: true },
            listeners: {
                move(event) {
                    var target = event.target;
                    var x = position.x;
                    var y = position.y;

                    target.style.width = event.rect.width + "px";
                    target.style.height = event.rect.height + "px";

                    position.x += event.deltaRect.left;
                    position.y += event.deltaRect.top;

                    target.style.webkitTransform = target.style.transform =
                        "translate(" + x + "px," + y + "px)";

                },
            },
            modifiers: [
                interact.modifiers.restrictSize({
                    min: { width: 400, height: 400 },
                    max: { width: 800, height: 800 },
                })
            ]
        });
    }, [])
    return <div className="draggable-area">
        <div ref={draggableAreaRef} className="equation-editor-popup-view">
            <div className="equation-editor-popup-header">
                <h4 className="equation-editor-popup-header-title">
                    ✥ Equation
                </h4>
                <button
                    className="equation-editor-popup-cancel-button"
                    onClick={props.close}>
                    Cancel
                </button>
                <button
                    className="equation-editor-popup-submit-button"
                    onClick={() => {
                        setLoading(true);
                        if (editor) {
                            let e = editor;
                            e.getSvg((svg) => {
                                props.writeEquation(svg, e.getLatex(), props.editNode);
                            }, () => {
                                setLoading(false);
                                window.alert(
                                    "Failed to create equation. If this problem continues, please alert your instructor."
                                );
                            })
                        } else {
                            props.close()
                        }
                    }}>
                    Insert
                </button>
            </div>
            <div>
                {loading && <img className="equation-editor-loading" style={{
                    width: "10%",
                    maxWidth: "40px",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    margin: "auto",
                }} src={loader} />}
                <EditorContainer uuid={uuid} />
            </div>
        </div>
    </div>
}